// Nonce REST WordPressa (X-WP-Nonce) — NIE jest to token uwierzytelniający
// sam w sobie (tym jest ciasteczko sesji, którego JS nawet nie odczytuje,
// tylko przeglądarka wysyła je automatycznie). Nonce jest wymagany przez
// rdzeń WordPressa jako dodatkowe zabezpieczenie CSRF przy żądaniach
// uwierzytelnionych ciasteczkiem.
//
// Samo logowanie (ustawianie nonce po zalogowaniu przez mu-plugin SSO)
// dodajemy w kroku 4 — na razie ta funkcja pozwala warstwie koszyka
// odróżnić gościa (brak nonce) od zalogowanego użytkownika.
const NONCE_STORAGE_KEY = 'wp_rest_nonce';

export const getNonce = (): string | null => {
    return localStorage.getItem(NONCE_STORAGE_KEY);
};

export const setNonce = (nonce: string): void => {
    if (nonce) {
        localStorage.setItem(NONCE_STORAGE_KEY, nonce);
    }
};

export const clearNonce = (): void => {
    localStorage.removeItem(NONCE_STORAGE_KEY);
};
